'use client';

import clsx from 'clsx';
import { ButtonNext, CarouselContext } from 'pure-react-carousel';
import { FC, useContext, useEffect, useState } from 'react';
import config from 'config-base';
import { CarouselButtonProps } from '../types';

import styles from '../Carousel.module.css';

const NextButton: FC<CarouselButtonProps> = ({
  buttonsAbsolute,
  hideButtons,
  total,
  step,
  arrowClassName,
  nextArrowClasses,
}) => {
  const carouselContext = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);

  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  return (
    !hideButtons && (
      <ButtonNext
        className={clsx(
          styles.carouselButtons,
          styles.nextButton,
          {
            [styles.carouselButtonRight]: buttonsAbsolute,
            [`${styles.carouselButtonRightAGD} ${styles.carouselButtonsAGD}`]:
              buttonsAbsolute && config.brandCode !== '0',
            [styles.nextButtonAGD]: config.brandCode !== '0',
          },
          arrowClassName,
          nextArrowClasses,
        )}
        disabled={step ? currentSlide + step === total : false}
      >
        <span></span>
      </ButtonNext>
    )
  );
};

export default NextButton;
